<template>
  <div class="trading-goald-content margin-general">
    <div class="trading-goald-text-container">
      <p class="trading-goal-title heading-h3">
        {{ $t("trading.trading-goal.title") }}
      </p>
      <!-- <p class="trading-goal-text body-4">
        {{ $t("trading.trading-goal.text1") }}
      </p>
      <p class="trading-goal-text body-4">
        {{ $t("trading.trading-goal.text2") }}
      </p> -->
      <NuxtLink :to="localPath('/trading/platforms')" class="second-button-small body-6-bold">
          {{ $t("trading.trading-goal.explore") }}
      </NuxtLink>
    </div>
    <div class="trading-goald-carousel-container">
      <swiper
        :spaceBetween="14"
        :slidesPerGroup="1"
        :pagination="true"
        :navigation="false"
        :loop="true"
        :modules="modules"
        class="swiper"
        :breakpoints="{
          '600': {
            slidesPerView: 1,
            spaceBetween: 15,
            slidesPerGroup: 2,
          },
          '1200': {
            pagination: false,
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 2,
          },
        }"
      >
        <swiper-slide
          v-for="row in cards"
          :key="row.imgSrc"
          class="content-slide"
        >
          <div class="title-box">
            <img :src="row.imgSrc" :alt="row.alt" class="img-card" />
            <p>{{ $t(row.title) }}</p>
          </div>
          <div class="text">
            <p class="desc body-4">{{ $t(row.desc) }}</p>
          </div>
        </swiper-slide>
      </swiper>

      <NuxtLink :to="localPath('/trading/platforms')" class="second-button-extrasmall">
          {{ $t("trading.trading-goal.explore") }}
      </NuxtLink>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";



import { Autoplay, Pagination, Navigation } from "swiper/modules";
const localPath = useLocalePath();
const cards = ref([
  /* {
    imgSrc: "/images/trading/logo2.svg",
    alt: "Metatrader 4 Logo",
    title: "trading.trading-goal.title1",
    desc: "trading.trading-goal.item1",
  }, */
  {
    imgSrc: "/images/trading/logo2.svg",
    alt: "Metatrader 5 Logo",
    title: "trading.trading-goal.title2",
    desc: "trading.trading-goal.item2",
  },
  /* {
    imgSrc: "/images/trading/logo3.svg",
    alt: "cTrader Logo",
    title: "trading.trading-goal.title3",
    desc: "trading.trading-goal.item3",
  },
  {
    imgSrc: "/images/trading/logo4.svg",
    alt: "Sterling Trader",
    title: "trading.trading-goal.title4",
    desc: "trading.trading-goal.item4",
  },
  {
    imgSrc: "/images/trading/logo5.svg",
    alt: "Lightspeed Logo",
    title: "trading.trading-goal.title5",
    desc: "trading.trading-goal.item5",
  },
  {
    imgSrc: "/images/trading/logo6.svg",
    alt: "Takion Logo",
    title: "trading.trading-goal.title6",
    desc: "trading.trading-goal.item6",
  },
  {
    imgSrc: "/images/trading/logo7.svg",
    alt: "DAS Logo",
    title: "trading.trading-goal.title7",
    desc: "trading.trading-goal.item7",
  },
  {
    imgSrc: "/images/trading/logo8.svg",
    alt: "CQG",
    title: "trading.trading-goal.title8",
    desc: "trading.trading-goal.item8",
  },
  {
    imgSrc: "/images/trading/logo9.svg",
    alt: "FIX/API",
    title: "trading.trading-goal.title9",
    desc: "trading.trading-goal.item9",
  }, */
]);
const modules = ref([Autoplay, Pagination, Navigation]);
</script>